export const cdfConstants = {
  LOAD: 'cdf/LOAD',
  LOAD_SUCCESS: 'cdf/LOAD_SUCCESS',
  LOAD_FAIL: 'cdf/LOAD_FAIL',
  FLUSH: 'cdf/FLUSH',
  SAVE_CDF: 'cdf/SAVE_CDF',
  ALL_CDF: 'cdf/ALL_CDF',
  FLUSH_ERR:'cdf/FLUSH_ERR'
};
